import { createTPluginFactory } from '../../plate';
import { KEY_NODE_ID } from '../../pluginKeys';
import { withNodeId } from './withNodeId';

export const createNodeIdPlugin = createTPluginFactory({
  key: KEY_NODE_ID,
  withOverrides: withNodeId,
});
